import { Flex } from "@ecco/ui/flex";
import HttpErrorMessage from "./HttpErrorMessage";

type ErrorPageContentProps = {
    title?: string;
    errorCode?: number;
    message?: string;
};
export const ErrorPageContent = ({
    title = "Something went wrong",
    message = "We're sorry, but something went wrong on our end. Please try refreshing the page.",
    errorCode = 500,
}: ErrorPageContentProps) => {
    return (
        <Flex>
            <div hidden data-testid={`http${errorCode}`} />
            <HttpErrorMessage headline={title} text={message} errorCode={errorCode} />
        </Flex>
    );
};
